<template>
  <v-container id="reset-password-request">
    <v-row justify="center">
      <v-col lg="6">
        <MaterialCard
          :title="this.$t('title.reset_password_request')"
          color="primary"
          elevation="0"
        >
          <v-form
            v-model="formValid"
            ref="reset_password_request_form"
            spellcheck="false"
          >
            <v-row class="ma-0">
              <v-col>
                <v-text-field
                  v-model="email"
                  color="primary"
                  type="email"
                  validate-on-blur
                  required
                  :rules="rules.email"
                  :label="$t('label.email')"
                />
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="primary"
                  class="no-text-transform display-1"
                  type="submit"
                  :disabled="!formValid"
                  :loading="loading"
                  @click="resetPasswordRequest"
                  >{{ this.$t("button.send") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </MaterialCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaterialCard from "@/components/views/MaterialCard";

export default {
  name: "ResetPasswordRequest",
  components: { MaterialCard },
  data() {
    return {
      email: null,
      loading: false,
      formValid: false,
      rules: {
        email: [
          v => !!v || this.$t("rules.email_required"),
          v => /.+@.+\..+/.test(v) || this.$t("rules.email_not_valid")
        ]
      }
    };
  },
  methods: {
    resetPasswordRequest(e) {
      e.preventDefault();
      if (!this.$refs.reset_password_request_form.validate()) {
        return;
      }

      this.loading = true;
      this.$store
        .dispatch("user/resetPasswordRequest", {
          email: this.email
        })
        .then(() => {
          this.$store.commit("viewstate/notify", {
            color: "success",
            text: this.$t("success.password_reset_request_received_mail")
          });
          this.$router.push("/");
        })
        .catch(() => {
          this.$store.commit("viewstate/notify", {
            color: "error",
            text: this.$t("error.password_reset_request_failed")
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped></style>
